import React, { useEffect } from "react";
import { useAppProvider } from "../Providers/appProvider/AppProvider";
import useDbName from "../hooks/useDbName";
import { AppstoreApi } from "../api";
import { authTokenPayload } from "../config/constant";
import { AppDetailsActionType } from "../Providers/appProvider/reducers/appDetailsReducer";

export default function Layout({ children }) {
  const dbName = useDbName();
  const { state, dispatch } = useAppProvider();

  const {
    appDetails: { appDetails },
  } = state;

  // const getReviews = async (appid) => {
  //   const payload = authTokenPayload({ appid: appid, limit: 1 });
  //   try {
  //     const data = await AppstoreApi.getReviews(payload);
  //     return Array.isArray(data?.reviews) ? data?.reviews : [];
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const prepareApps = async () => {
    try {
      dispatch({
        type: AppDetailsActionType.SET_APPS_LOADING,
        payload: true,
      });

      const appsDetails = [];
      const { rows } = await AppstoreApi.getAllApps(dbName);
      if (rows) {
        for (let row of rows) {
          const app = JSON.parse(row?.v);
          appsDetails.push({ ...app, reviews: [] });
        }
      }

      dispatch({
        type: AppDetailsActionType.SET_APP_DETAILS,
        payload: { appDetails: appsDetails },
      });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch({
        type: AppDetailsActionType.SET_APPS_LOADING,
        payload: false,
      });
    }
  };

  useEffect(() => {
    if (!dbName) return;
    if (appDetails.length > 0) return;

    prepareApps();
  }, [appDetails.length, dbName, dispatch]);

  return <>{children}</>;
}
